import React, { useEffect, useState } from 'react'
import style from "./SubscriptionDetails.module.css"
import subscriptionImage from "../../assests/subscriptionMail.png"
import { baseurl } from "../Url";
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MdDownload } from "react-icons/md";
import { HiOutlineArrowRight } from "react-icons/hi";


const SubscriptionDetails = () => {
  const navigate = useNavigate();
  const UserName = localStorage.getItem("username");
  const key = JSON.parse(localStorage.getItem("access-token"));
  const UserID = localStorage.getItem("USERID");

  const [subscriptionData, setSubscriptionData] = useState({});
  const [loading, setLoading] = useState(true);
  const { userDetails } = useSelector((state) => state.user);

  async function fetchSubscriptionDetails() {
    try {
      const res = await fetch(`${baseurl}/subscribe/user/data`, {
        method: "POST",
        body: JSON.stringify({ user_id: UserID }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });
      const data = await res.json();
      setSubscriptionData(data.status === true ? data.data : {});
    } catch {
      setSubscriptionData({});
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (UserID) {
      fetchSubscriptionDetails();
    } else {
      setLoading(false);
    }
  }, [UserID]);

  const handleSubscribe = () => {
    navigate("/subscribe", {
      state: {
        Username: UserName,
        userID: UserID,
        count: userDetails?.user_type === "Trail" ? userDetails?.trail_count : undefined,
      },
    });
  };

  const isActive = userDetails?.user_type === "Trail"
    ? userDetails?.Status === "Active"
    : subscriptionData?.subscription_status;

  const endDate = subscriptionData?.subscription_end_date
    ? dayjs(subscriptionData.subscription_end_date.$date || subscriptionData.subscription_end_date).format('MMMM D, YYYY')
    : "—";

  if (loading) {
    return (
      <div className={style.container}>
        <div className={style.loadingState}>
          <div className={style.spinner} />
          <p>Loading your subscription...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={style.container}>
      <div className={style.subscription}>
        <h1 className={style.pageTitle}>Subscription Details</h1>
        <div className={style.welcomeSection}>
          <div className={style.welcomeSectionLeft}>
            <h2 className={style.greeting}>Hello, {UserName}!</h2>
            <p className={style.subtitle}>Take a look at your subscription plan.</p>
          </div>
          <div className={style.welcomeSectionRight}>
            <img src={subscriptionImage} alt="" className={style.welcomeImage} />
          </div>
        </div>

        <section className={style.card}>
          <h3 className={style.cardTitle}>Subscription Plan</h3>
          <div className={style.planContent}>
            <div className={style.planInfo}>
              <div className={style.planNameRow}>
                <h4 className={style.planName}>{subscriptionData?.product_name || "Grammar Locker"}</h4>
                {isActive && <span className={style.planBadge}>Your Plan</span>}
              </div>
              <p className={style.planPrice}>
                {subscriptionData?.amount_paid ? `${subscriptionData.amount_paid} ${subscriptionData?.currency || "INR"}` : "—"}
              </p>
              <div className={style.statusRow}>
                <span className={`${style.badge} ${isActive ? style.badgeActive : style.badgeExpired}`}>
                  {isActive ? "Active" : "Expired"}
                </span>
                <span className={style.dateText}>
                  {isActive ? "Active until" : "Expired"} {endDate}
                </span>
              </div>
            </div>
            <button type="button" className={style.primaryBtn} onClick={handleSubscribe}>
              {userDetails?.user_type === "Trail" ? "Subscribe Now" : "Renew Subscription"}
              <HiOutlineArrowRight />
            </button>
          </div>
        </section>

        {((userDetails?.user_type !== "Trail") || (subscriptionData && Object.keys(subscriptionData).length > 0)) && (
          <section className={style.card}>
            <div className={style.billingCardHeader}>
              <h3 className={style.cardTitle}>Billing Details</h3>
              <button
                type="button"
                className={style.changeBillingLink}
                onClick={() => navigate("/subscribe", { state: { Username: UserName, userID: UserID } })}
              >
                Change billing information
                <HiOutlineArrowRight />
              </button>
            </div>
            <div className={style.billingInfo}>
              <div>
                <span className={style.label}>Name</span>
                <p className={style.value}>{subscriptionData?.Username || subscriptionData?.FirstName || "—"}</p>
              </div>
              <div>
                <span className={style.label}>Email</span>
                <p className={style.value}>{subscriptionData?.Email || "—"}</p>
              </div>
            </div>
            <div className={style.tableWrap}>
              <table className={style.table}>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Reference</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{subscriptionData?.product_name || "—"}</td>
                    <td>{subscriptionData?.ref_id || "—"}</td>
                    <td>
                      {subscriptionData?.subscription_start_date
                        ? dayjs(subscriptionData.subscription_start_date.$date || subscriptionData.subscription_start_date).format('DD/MM/YYYY')
                        : 'N/A'}
                    </td>
                    <td>{subscriptionData?.amount_paid || "—"} {subscriptionData?.currency || "INR"}</td>
                    <td>
                      <span className={`${style.badge} ${subscriptionData?.subscription_status ? style.badgeActive : style.badgeExpired}`}>
                        {subscriptionData?.subscription_status ? "Active" : "Expired"}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {subscriptionData?.receipt_url && (
              <button
                type="button"
                className={style.downloadBtn}
                onClick={() => window.open(subscriptionData.receipt_url, "_blank")}
              >
                <MdDownload />
                Download Receipt
              </button>
            )}
          </section>
        )}
      </div>
    </div>
  );
}

export default SubscriptionDetails;
